import { render } from "./BankWireOrderDocument.vue?vue&type=template&id=deaf79c2&scoped=true"
import script from "./BankWireOrderDocument.vue?vue&type=script&lang=js"
export * from "./BankWireOrderDocument.vue?vue&type=script&lang=js"

import "./BankWireOrderDocument.vue?vue&type=style&index=0&id=deaf79c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deaf79c2"]])

export default __exports__